import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';

// import Rate from '../../components/Rate/Rate';
import { logging } from '../../actions/log';
import styles from './SoftDetailInfos.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ appDetailsData }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const [textNode, setTextNode] = useState(null);
  const [vtextNode, setVtextNode] = useState(null);

  const [briefNode, setBriefNode] = useState(null);
  const [vbriefNode, setVbriefNode] = useState(null);

  const [hasMore, setHasMore] = useState(true);
  const [hasBMore, setHasBMore] = useState(true);

  const [showDInfo, setShowDInfo] = useState(''); // 详情是否展示show more
  const [showWNew, setShowWNew] = useState(''); // 更新日志是否展示show more
  const [warmTips, setWarmTips] = useState(''); // 温馨提示

  const formatInfo = useCallback(info => {
    let infoStr = '';
    if (info) {
      infoStr = info;
      if (infoStr.indexOf('<p>&nbsp;</p>') > -1) {
        infoStr = infoStr.split('<p>&nbsp;</p>').join('');
      }
      if (infoStr.indexOf('<br />') > -1) {
        infoStr = infoStr.split('<br />').join('<br/>');
      }
      if (infoStr.indexOf('\r\n') > -1) {
        infoStr = infoStr.split('\r\n').join('');
      }
      if (infoStr.indexOf('\n') > -1) {
        infoStr = infoStr.split('\n').join('<br/>');
      }
      while (infoStr.indexOf('<br/><br/>') > -1) {
        infoStr = infoStr.split('<br/><br/>').join('<br/>');
      }
    }
    return infoStr;
  });

  useEffect(() => {
    if (appDetailsData && appDetailsData.detailInfo) {
      let showDInfoStr = appDetailsData.detailInfo;
      // setShowDInfo(showDInfoStr.split('\n').join('<br/>'));
      setShowDInfo(formatInfo(showDInfoStr));
    }

    if (appDetailsData && appDetailsData.whatNew) {
      const showWNewStr = appDetailsData.whatNew;
      // setShowWNew(showWNewStr.split('\n').join('<br/>'));
      setShowWNew(formatInfo(showWNewStr));
    }

    if (appDetailsData && appDetailsData.warmTips) {
      const tips = appDetailsData.warmTips;
      // setWarmTips(tips.split('\n').join('<br/>'));
      setWarmTips(formatInfo(tips));
    }
  }, [appDetailsData]);

  const handleShowMoreDInfo = useCallback(
    isShow => {
      setHasMore(false);
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_SM_Detail',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: appDetailsData.softID,
            softType: '0',
          },
          param3: appDetailsData.bizInfo,
        }),
      );
    },
    [appDetailsData],
  );

  const handleShowMoreWNew = useCallback(
    isShow => {
      setHasBMore(false);
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_SM_New',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: appDetailsData.softID,
            softType: '0',
          },
          param3: appDetailsData.bizInfo,
        }),
      );
    },
    [appDetailsData],
  );

  return (
    <div className={styles.detail_infos}>
      {false && appDetailsData && appDetailsData.warmTips && (
        <div className={styles.detail_tips}>
          <span className={styles.tips_title}>温馨提示</span>
          <div
            className={styles.tips_content}
            dangerouslySetInnerHTML={{
              __html: warmTips,
            }}
          />
        </div>
      )}
      {appDetailsData && appDetailsData.detailInfo && (
        <div className={styles.detail_discript_2}>
          <div className={styles.discript_title}>简介</div>
          <div
            className={classNames({ [styles.discript_text]: hasMore }, styles.discript_text_tem)}
            dangerouslySetInnerHTML={{
              __html: showDInfo,
            }}
            ref={ref => setTextNode(ref && ref.clientHeight)}
          />
          <div
            style={{
              position: 'fixed',
              top: '-9999px',
              opacity: 0,
            }}
            className={styles.discript_text_tem}
            dangerouslySetInnerHTML={{
              __html: showDInfo,
            }}
            ref={ref => setVtextNode(ref && ref.clientHeight)}
          />
          {textNode < vtextNode && hasMore && (
            <div
              className={styles.discript_text_more}
              onClick={() => {
                handleShowMoreDInfo(showDInfo);
              }}
            >
              更多
            </div>
          )}
        </div>
      )}
      {appDetailsData && appDetailsData.whatNew && (
        <div className={styles.detail_discript}>
          <div className={styles.discript_title}>更新日志</div>
          <div
            className={classNames({ [styles.discript_text]: hasBMore }, styles.discript_text_tem)}
            dangerouslySetInnerHTML={{
              __html: showWNew,
            }}
            ref={ref => setBriefNode(ref && ref.clientHeight)}
          />
          <div
            className={classNames(styles.discript_text_tem)}
            style={{
              position: 'fixed',
              top: '-9999px',
              opacity: 0,
            }}
            dangerouslySetInnerHTML={{
              __html: showWNew,
            }}
            ref={ref => setVbriefNode(ref && ref.clientHeight)}
          />
          {briefNode < vbriefNode && hasBMore && (
            <div
              className={styles.discript_text_more}
              onClick={() => {
                handleShowMoreWNew(showWNew);
              }}
            >
              更多
            </div>
          )}
        </div>
      )}

      {appDetailsData.hardwareConfigurationList &&
        appDetailsData.hardwareConfigurationList.length > 0 && (
          <div className={styles.detail_device}>
            <div className={styles.detail_title}>最低配置要求</div>
            <div className="device">
              {appDetailsData.hardwareConfigurationList.map((item, i) => (
                <div className="device_item" key={i}>
                  <div className="device_item_name">
                    <span className="device_item_point" />
                    {item.desc}：
                  </div>
                  <div className="device_item_value">{item.value} </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  );
});
